import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';

export interface ConsignacaoResumo {
  tipoFolha: string;       
  rubricaCodigo: string;   
  rubricaDescricao: string;
  valor: number;           
  isDesconto: boolean;    
}

export interface ConsignacaoDetalhe {
    transacao: string;
    valor: string;
    competencia: string;
    folha: string;
    filial: string;
    matricula: string;
    nome: string;
    lotacao: string;
    vinculo: string;
    admissao: string;
    cargo_funcao: string;
    oco: string;
    pag: string;
    situacao: {
      codigo: string;
      nome: string;
      data: string;
    };
    verba: {
      codigo: string;
      nome: string;
    };
  }

@Injectable({ providedIn: 'root' })
export class ConsignacoesService {
  private readonly relatoriosBase = 'https://api-relatorios-php.elogica.info';
  private readonly basicUser = '3l0g1k4';
  private readonly basicPass = 'dtr5x8!qAa6>';

  constructor(private http: HttpClient) {}

  private basicHeadersGET(): HttpHeaders {
    const token = btoa(`${this.basicUser}:${this.basicPass}`);
    return new HttpHeaders({
      Authorization: `Basic ${token}`,
      Accept: 'application/json',
    });
  }

listarCompetencias(sigla: string, empfil: string) {
    const url = `${this.relatoriosBase}/competencias-folha/${sigla}/${empfil}`;
    return this.http.get<any>(url, { headers: this.basicHeadersGET() });
  }

listarResumo(sigla: string, competencia: string, empfil: string) {
    const url = `${this.relatoriosBase}/consignacoes/debito-credito/${sigla}/${competencia}/${empfil}`;
    return this.http.get<any>(url, { headers: this.basicHeadersGET() });
  }

listarDetalhes(sigla: string, competencia: string, empfil: string, rubrica: string) {
    const url = `${this.relatoriosBase}/consignacoes/debito-credito/${sigla}/${competencia}/${empfil}/${rubrica}`;
    return this.http.get<ConsignacaoDetalhe[]>(url, { headers: this.basicHeadersGET() });
  }
}
